import layout from '@/components/common/layout';
import userList from '../views/user/list';

export default [
    {
        path: '/user',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "账户列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '12',// 父选项
                        child: 'user_list',// 子选项
                    }
                },
                component: userList,
            },
        ]
    },
];
